import { utils } from '../../Foundation';
import { Select } from '../../Feature/select';

export class DatatableFooter {
    constructor(inputSettings) {
        this._refs = {
            el: inputSettings.el,
            currentPage: inputSettings.currentPage,
            state: inputSettings.state,
            settings: inputSettings.settings,
            eventList: inputSettings.eventList
        }

        this._createTableFooter();
    }

    // Create table footer
    _createTableFooter() {
        const
            oFooter = utils.createElement('div', { 'class': 'datatable__footer', }),
            oRow = utils.createElement('div', { 'class': 'row' }, oFooter),
            oInfo = utils.createElement('div', { 'class': 'col-xs-12 col-sm-12 col-md-3' }, oRow),
            oPagination = utils.createElement('div', { 'class': 'col-xs-12 col-sm-12 col-md-6 text-center' }, oRow),
            oPagesize = utils.createElement('div', { 'class': 'col-xs-12 col-sm-12 col-md-3' }, oRow);

        // Asign elements to global scope
        this._refs.footer = oFooter;
        this._refs.pagesize = oPagesize;
        this._refs.pagination = oPagination;
        this._refs.info = oInfo;

        // Create sub-elements
        const rhytm = this._paginate();
        this._appendPagination(rhytm.pages, rhytm.currentPage, rhytm.startPage, rhytm.endPage);
        this._refs.el.append(oFooter);
        
        this._appendInfo();
        if(rhytm.totalItems > this._refs.settings.pageSize.values[0]) {
            this._appendPagesize();
        }
        
        // Custom event to trigger footer update
        this._refs.el.addEventListener('updateTableFooter', () => {
            this._updateFooter();
        });
    }

    _updateFooter() {
        const rhytm = this._paginate();
        this._appendInfo();
        this._appendPagination(rhytm.pages, rhytm.currentPage, rhytm.startPage, rhytm.endPage);
    }

    /**
     * Create and append PageSize dropdown
     */
     _appendPagesize() {
        const
            oHtml = utils.createElement('div', {
                'class': 'form-select',
                'data-select': ''
            }),
            oSelect = utils.createElement('select', {
                'name': 'pagesize',
                'innerHTML': `${this._refs.settings.pageSize.values.map(item => `<option value="${item}">${item}</option>`).join("")}`
            }, oHtml);

        this._refs.el.setAttribute('data-page-size', this._refs.settings.pageSize.current);
        // Event binding
        oSelect.addEventListener('change', this._onPagesizeChange.bind(this));
        new Select(oHtml);

        // Append HTML
        this._refs.pagesize.appendChild(oHtml);
    }

    /**
     * Append/Update current table information
     */
     _appendInfo() {
        const
            rhytm = this._paginate(),
            text = typeof this._refs.settings.translations.footerInfo != 'undefined' && this._refs.settings.translations.footerInfo.trim().length ? this._refs.settings.translations.footerInfo : 'Showing {startIndex} to {endIndex} of {total} results',
            oHtml = utils.createElement('span', {
                'class': 'datatable__info',
                'innerHTML': text.replace('{startIndex}', parseInt(rhytm.startIndex + 1)).replace('{endIndex}', parseInt(rhytm.endIndex + 1)).replace('{total}', rhytm.totalItems)
            });

        this._refs.info.innerHTML = '';
        if(rhytm.totalItems > 0) {
            this._refs.info.appendChild(oHtml);
        }
    }

    /**
     * Append pagination to component
     */
     _appendPagination(pages, currentPage, startPage, endPage) {
        if(pages.length > 0) {
            let oHtml = utils.createElement('ul', {
                'class': 'v-pagination'
            });

            // Create left-arrow
            const
                oArrowLeft = utils.createElement('li', {
                    'class': currentPage === startPage ? 'disabled' : ''
                }, oHtml),
                oArrowLeftLink = utils.createElement('div', {
                    'tabindex': currentPage == startPage ? '-1' : '0',
                    'lang': 'en',
                'aria-labelledby': 'Previous',
                'role': 'button',
                    'class': 'button is-left',
                    'innerHTML': '&lsaquo;',
                    'onclick': this._onPaginationArrowClick.bind(this)
                }, oArrowLeft);

                oArrowLeftLink.addEventListener('keyup', (e) => {
                    if(e.key === 'Enter') {
                        e.target.click();
                    }
                });

            // Items
            pages.forEach(x => {
                let
                    oItem = utils.createElement('li', {
                        'class': currentPage === x ? 'active' : ''
                    }, oHtml),
                    oLink = utils.createElement('div', {
                        'tabindex': '0',
                        'lang': 'en',
                        'aria-label': x,
                    'role': 'button',
                        'class': 'button',
                        'innerHTML': x,
                        'onclick': this._onPaginationItemClick.bind(this)
                    }, oItem);

                    oLink.addEventListener('keyup', (e) => {
                        if(e.key === 'Enter') {
                            e.target.click();
                        }
                    });
            });

            // right arrow
            const
                oArrowRight = utils.createElement('li', {
                    'class': currentPage == endPage ? 'disabled' : ''
                }, oHtml),
                oArrowRightLink = utils.createElement('div', {
                    'tabindex': currentPage == endPage ? '-1' : '0',
                    'lang': 'en',
                'aria-labelledby': 'Next',
                'role': 'button',
                    'class': 'button is-right',
                    'innerHTML': '&rsaquo;',
                    'onclick': this._onPaginationArrowClick.bind(this)
                }, oArrowRight);

                oArrowRightLink.addEventListener('keyup', (e) => {
                    if(e.key === 'Enter') {
                        e.target.click();
                    }
                });

            this._refs.pagination.innerHTML = '';
            this._refs.pagination.appendChild(oHtml);
        }
    }

    /**
     * _Paginate
     * Calculate required variables for pagination 
     */
     _paginate() {
        // Update current page
        this._refs.currentPage = Number(this._refs.el.getAttribute('data-currentPage'));
        // calculate total pages
        let totalPages = Math.ceil(this._refs.state.totalItems / this._refs.settings.pageSize.current);

        // ensure current page isn't out of range
        if (this._refs.currentPage < 1) {
            this._refs.currentPage = 1;
        } else if (this._refs.currentPage > totalPages) {
            this._refs.currentPage = totalPages;
        }

        let startPage, endPage;
        if (totalPages <= this._refs.settings.maxPages) {
            // total pages less than max so show all pages
            startPage = 1;
            endPage = totalPages;
        } else {
            // total pages more than max so calculate start and end pages
            let maxPagesBeforeCurrentPage = Math.floor(this._refs.settings.maxPages / 2);
            let maxPagesAfterCurrentPage = Math.ceil(this._refs.settings.maxPages / 2) - 1;
            if (this._refs.currentPage <= maxPagesBeforeCurrentPage) {
                // current page near the start
                startPage = 1;
                endPage = this._refs.settings.maxPages;
            } else if (this._refs.currentPage + maxPagesAfterCurrentPage >= totalPages) {
                // current page near the end
                startPage = totalPages - this._refs.settings.maxPages + 1;
                endPage = totalPages;
            } else {
                // current page somewhere in the middle
                startPage = this._refs.currentPage - maxPagesBeforeCurrentPage;
                endPage = this._refs.currentPage + maxPagesAfterCurrentPage;
            }
        }

        // calculate start and end item indexes
        let startIndex = (this._refs.currentPage - 1) * this._refs.settings.pageSize.current;
        let endIndex = Math.min(startIndex + this._refs.settings.pageSize.current - 1, this._refs.state.totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        let pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);

        return {
            totalItems: this._refs.state.totalItems,
            currentPage: this._refs.currentPage,
            pageSize: this._refs.settings.pageSize.current,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }

    // When change number of items to be display
    _onPagesizeChange(e) {
        // Set new value
        this._refs.currentPage = 1;
        this._refs.settings.pageSize.current = Number(e.target.options[e.target.selectedIndex].value);
        this._refs.el.setAttribute('data-page-size', this._refs.settings.pageSize.current);
        // Update parent container
        this._refs.eventList.onChangePageSize(e);
        // Update overview
        this._updateFooter();
    }

    // When select page number in pagination
    _onPaginationItemClick(e) {
        e.preventDefault();
        this._refs.currentPage = parseInt(e.target.innerHTML);
        // Update parent container
        this._refs.eventList.onPageItemClick(e);
        // Update overview
        this._updateFooter();
        this._setFocus();
    }

    // When select next or previous icon in pagination
    _onPaginationArrowClick(e) {
        e.preventDefault();
        // Prevent further action when reach last page
        if(e.target.parentNode.classList.contains('disabled')) return; 

        // Direction
        if (e.target.classList.contains('is-left')) {
            this._refs.currentPage--;
            this._setFocusArrow('left')
        } else {
            this._refs.currentPage++;
            this._setFocusArrow('right')
        }
        // Update parent container
        this._refs.eventList.onArrowClick(e);
        // Update overview
        this._updateFooter();
    }

    _setFocus() {
        this._refs.pagination.querySelector('.active').querySelector('.button').focus();
    }

    _setFocusArrow(side) {
        if(side === 'left') {
            const arrowLeft = this._refs.pagination.querySelector('.is-left');
            arrowLeft.focus();
            if(arrowLeft.parentNode.classList.contains('disabled')) {
                this._setFocus();
            }
        } else {
            const arrowRight = this._refs.pagination.querySelector('.is-right');
            arrowRight.focus();
            if(arrowRight.parentNode.classList.contains('disabled')) {
                this._setFocus();
            }
        }
    }
}